import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { LoadingButton } from 'src/components';

interface Props {
  title?: string;
  subTitle?: string;
  label?: string;
  placeholder?: string;
  isVisible: boolean;
  handleClose: () => void;
  onSavePress: (value: string) => void;
  loading?: boolean;
  required?: boolean;
  errorMessage?: string;
  initialValue?: string;
}

const ReasonDialog = ({
  title = 'Title',
  subTitle = '',
  label = 'Reason',
  placeholder = '',
  isVisible = false,
  handleClose,
  onSavePress,
  loading = false,
  required = true,
  errorMessage = 'This field is required',
  initialValue = ''
}: Props) => {
  const [value, setValue] = useState<string>(initialValue);
  const [error, setError] = useState<string>('');

  const resetState = () => {
    setValue('');
    setError('');
  };

  const onSaveBtnPress = () => {
    if (loading) {
      return;
    }

    if (required && !value.trim()) {
      setError(errorMessage);
      return;
    }

    onSavePress(value);
    resetState();
  };

  const onCancelBtnPress = () => {
    resetState();
    handleClose();
  };

  return (
    <Dialog
      open={isVisible}
      onClose={handleClose}
      aria-labelledby="textarea-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="textarea-dialog-title">{title}</DialogTitle>

      <DialogContent>
        {subTitle && <DialogContentText>{subTitle}</DialogContentText>}

        <TextField
          error={error !== ''}
          helperText={error}
          autoFocus
          margin="dense"
          id="textarea-dialog-field"
          label={label}
          placeholder={placeholder}
          fullWidth
          required={required}
          multiline
          minRows={4}
          variant="outlined"
          value={value}
          onChange={(e) => {
            setError('');
            setValue(e.target.value);
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancelBtnPress}>Cancel</Button>

        <LoadingButton
          title="Save"
          loading={loading}
          onClick={onSaveBtnPress}
          color="primary"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ReasonDialog;
